import { selectedViewSelector } from "./selectedViewSelector";
import { filtersFromViewCombiner } from "./filtersFromViewCombiner";
import { RootState } from "../../../../store";

export const viewServicesFilterSelector = (state: RootState) => {
  const view = selectedViewSelector(state);

  return filtersFromViewCombiner("service", view?.filters);
};
